<div class="container-fluid m-0 p-0">
    <div class="row">
        <div class="col-12 d-flex flex-wrap justify-content-between">
            <!-- <div class="col-12 d-flex flex-wrap justify-content-between" *ngIf="globals.checkUserHasPermission('COUNTRIES - CREATE')"> -->
            <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0"
                routerLink="/schedule/schedule-setup-create"><i class="fas fa-plus"></i> {{ "ADD" | translate |
                titlecase }}</button>
        </div>

        <div class="col-12">

            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3">{{ "SCHEDULE_SETUP" | translate | titlecase }}</h5>

                <app-loader [show]="showLoader"></app-loader>

                <div class="table-responsive py-3" *ngIf="!showLoader">
                    <table *ngIf="schedules.length >= 1" class="table-striped" id="datatable">
                        <thead>
                            <tr>
                                <th rowspan="2">{{ "ID" | translate | titlecase }}</th>
                                <th rowspan="2">{{ "EFFECTIVE_DATE_FROM" | translate | titlecase }}</th>
                                <th rowspan="2">{{ "EFFECTIVE_DATE_TO" | translate | titlecase }}</th>
                                <th rowspan="2">{{ "TIME_SLOT" | translate | titlecase }} [{{ "MIN" | translate | titlecase }}]</th>
                                <!-- <th rowspan="2">{{ "BREAK_TIME_SLOT" | translate | titlecase }} [{{ "MIN" | translate | titlecase }}]</th> -->
                                <th colspan="7" style="text-align: center;">{{ "NUMBER_OF_TIME_SLOTS_PER_DAY" | translate | titlecase }}</th>
                                <th rowspan="2">{{ "WEEK_STARTS" | translate | titlecase }}</th>
                                <th rowspan="2">{{ "ACTIVE" | translate | titlecase }}</th>
                                <th class="border-0 font-14 px-2 text-grey" rowspan="2">{{ "PREVIEW" | translate | titlecase
                                    }}</th>
                                <th class="border-0 font-14 px-2 text-grey" rowspan="2">{{ "MODIFY" | translate | titlecase
                                    }}</th>
                            </tr>
                            <tr>
                                <th>{{ "SUN" | translate | titlecase }}</th>
                                <th>{{ "MON" | translate | titlecase }}</th>
                                <th>{{ "TUE" | translate | titlecase }}</th>
                                <th>{{ "WED" | translate | titlecase }}</th>
                                <th>{{ "THU" | translate | titlecase }}</th>
                                <th>{{ "FRI" | translate | titlecase }}</th>
                                <th>{{ "SAT" | translate | titlecase }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let res of schedules">
                                <td>{{res?.id}}</td>
                                <td>{{res?.effectiveFrom | date}}</td>
                                <td>{{res?.effectiveTo | date}}</td>
                                <td>{{res?.periodTimeSlot}}</td>
                                <!-- <td>{{res?.breakTimeSlot}}</td> -->
                                <td>{{res?.timeSlotSun}}</td>
                                <td>{{res?.timeSlotMon}}</td>
                                <td>{{res?.timeSlotTue}}</td>
                                <td>{{res?.timeSlotWed}}</td>
                                <td>{{res?.timeSlotThu}}</td>
                                <td>{{res?.timeSlotFri}}</td>
                                <td>{{res?.timeSlotSat}}</td>
                                <td>{{res?.weekStart}}</td>
                                <td>{{(res?.active == 'YES')? ('YES' | translate | titlecase) : ('NO' | translate |
                                    titlecase) }}</td>
                                <td class="text-bold text-warning">
                                    <a class="btn btn-sm btn-link text-warning" routerLink="/schedule/schedule-setup-preview"
                                        [queryParams]="{scheduleId: res?.id}"><i class="fas fa-search"></i>
                                        {{ "PRIVIEW" | translate | titlecase }}</a>
                                </td>
                                <td class="text-bold text-warning">
                                    <a class="btn btn-sm btn-link text-warning" routerLink="/schedule/schedule-setup-update"
                                        [queryParams]="{scheduleId: res?.id}"><i class="fas fa-edit"></i>
                                        {{ "MODIFY" | translate | titlecase }}</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>